import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";

export default function TabDynamics({ app, menuItemsStrings, ExportChartFootnote }) {
  return (
    <div className="container-fluid page-default kpi-row-double fillpage-body">
      <div className="row justify-content-start fillpage-row">

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 fillpage-col">

          {/* TOP band — KPIs (fixed) + charts (fill) */}
          <div className="band band-top">

            {/* KPI row — fixed height */}
            <div className="row justify-content-left band-kpis">

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                {/* KPI: total projects and programs */}
                <QlikCard
                  id="1470401f-10f2-4197-bffb-0dd9093799e8"
                  height="var(--kpi-h)"
                  showHeader={false}
                  showMaximize={false}
                  showExport={false}
                />
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                {/* KPI: total projects and programs needs */}
                <QlikCard
                  id="2ad95b17-1b66-477f-904a-167c09f91c9c"
                  height="var(--kpi-h)"
                  showHeader={false}
                  showMaximize={false}
                  showExport={false}
                />
              </div>
            </div>

            {/* Charts row — fills the rest of the top band */}
            <div className="row justify-content-left band-charts">

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 d-flex flex-column">
                <div className="row justify-content-center h-100">
                  <div className="col-12 d-flex flex-column">
                    {/* bar chart 1 */}
                    <QlikCard
                      id="bd046ba3-79f5-4fc0-9adc-783ce3878733"
                      height="100%"
                      showHeader={true}
                      showMaximize={false}
                      showExport={true}
                      showPdfExport
                      showImageExport={true}
                      exportImageWidth={1280}
                      exportImageHeight={720}
                      onBeforeExportHandler={async ({ vis, exportType }) => {
                        console.log(vis);
                        if (exportType in { pdf: true, image: true } && vis)
                          await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                      }}
                      onAfterExportHandler={async ({ vis, exportType }) => {
                        console.log('Export type: ', exportType);
                        if (exportType in { pdf: true, image: true })
                          vis.setOptions({ showTitles: false, footnote: "" });
                      }}
                      exportText={menuItemsStrings.exportText}
                      exportCompletedText={menuItemsStrings.exportCompletedText}
                      closeBtnText={menuItemsStrings.closeBtnText}
                      exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                      exportNoObjectText={menuItemsStrings.exportNoObjectText}
                    />
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 d-flex flex-column">
                <div className="row justify-content-center h-100">
                  <div className="col-12 d-flex flex-column">
                    {/* bar chart 2 */}
                    <QlikCard
                      id="1509ca20-ac62-4111-a4ba-3686c8c844f0"
                      height="100%"
                      showHeader={true}
                      showMaximize={false}
                      showExport={true}
                      showPdfExport
                      showImageExport={true}
                      exportImageWidth={1280}
                      exportImageHeight={720}
                      onBeforeExportHandler={async ({ vis, exportType }) => {
                        console.log(vis);
                        if (exportType in { pdf: true, image: true } && vis)
                          await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                      }}
                      onAfterExportHandler={async ({ vis, exportType }) => {
                        console.log('Export type: ', exportType);
                        if (exportType in { pdf: true, image: true })
                          vis.setOptions({ showTitles: false, footnote: "" });
                      }}
                      exportText={menuItemsStrings.exportText}
                      exportCompletedText={menuItemsStrings.exportCompletedText}
                      closeBtnText={menuItemsStrings.closeBtnText}
                      exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                      exportNoObjectText={menuItemsStrings.exportNoObjectText}
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* BOTTOM band — table */}
          <div className="band band-bottom band-fill">
            <QlikCard
              id="59c5a923-151a-4821-8f51-6a578012e403"
              height="100%"
              showHeader={true}
              showMaximize={true}
              showExport={true}
              onBeforeExportHandler={async ({ }) => {
                await app.variable.setStringValue('export_link', '1');
              }}
              onAfterExportHandler={async ({ }) => {
                app.variable.setStringValue('export_link', '0');
              }}
              exportText={menuItemsStrings.exportText}
              exportCompletedText={menuItemsStrings.exportCompletedText}
              closeBtnText={menuItemsStrings.closeBtnText}
              exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
              exportNoObjectText={menuItemsStrings.exportNoObjectText}
              actionsVisibility="always"
              copyCells="true"
              copiedSuccessMessage={menuItemsStrings.copiedSuccessMessage}
              copiedFailedMessage={menuItemsStrings.copiedFailedMessage}
            />
          </div>

        </div>


        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing fillpage-col">

          {/* TOP band — FilterPane (mirrors KPIs + charts band) */}
          <div className="band band-top filter-col">
            <div className="filter-grow">
              <QlikCard
                id="80389321-37cb-409f-b648-25f73168bb15"
                height="100%"
                showHeader={false}
                showMaximize={false}
                showExport={false}
                showOverlayer={false}
              />
            </div>
          </div>

          {/* BOTTOM band — selector + columns-selector (mirrors table band) */}
          <div className="band band-bottom filter-col">
            <div className="band-fixed">
              <QlikObject
                id="eee6b8ed-dd65-4633-b046-66e317013bd1"
                height="var(--selector-h)"
                showHeader={false}
                showMaximize={false}
                showExport={false}
                showOverlayer={false}
              />
            </div>
            <div className="filter-grow">
              <QlikCard
                id="8e953dbe-99e3-4ca8-befc-7f26051dd3f4"
                height="100%"
                showHeader={false}
                showMaximize={false}
                showExport={false}
                showOverlayer={false}
              />
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}